import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-dropdown-menu',
  templateUrl: './dropdown-menu.component.html',
  styleUrls: ['./dropdown-menu.component.scss'],
  standalone: true,
  imports: [MatButtonModule, MatIconModule, MatMenuModule, MatSelectModule, TranslateModule],
})
export class DropdownMenuComponent {
  @Input() title: string;
  @Input() icon?: string;
  @Input() iconType?: 'native' | 'svg' = 'native';
  @Input() options: { label: string; value: any; icon?: string; iconType?: string }[] = [];
  @Input() iconPlacement?: 'prefix' | 'suffix' = 'prefix';
  @Input() buttonStyle?: 'raised' | 'outlined' | 'unelevated';
  @Input() buttonColor?: 'primary';
  @Input() disabled = false;
  @Output() optionSelected = new EventEmitter<any>();

  onOptionClick(option: any): void {
    this.optionSelected.emit(option);
  }
}
